import { VIPSDataServiceURL } from "../Constants/GlobalConstant";
import { requestOptions ,MenuURL } from "../Constants/GlobalConstant";

export function getVendorIdFromSession() {
  let vendorId = "";
  try {
    const saRaw = localStorage.getItem("sessionArray");
    if (saRaw) {
      const arr = JSON.parse(saRaw);
      if (Array.isArray(arr)) {
        const vItem = arr.find(
          (it) => it && (it.Key === "vendor_id" || it.key === "vendor_id")
        );
        if (vItem && (vItem.Value != null || vItem.value != null))
          vendorId = String(vItem.Value ?? vItem.value);
      }
    }
  } catch (_) {}
  return vendorId;
}

export function openPopup(row, props, schemaResult, values) {
  var sessionId = props.searchParams.get("session_id");
  var PageID = props.searchParams.get("PageID");
  var labelref = props.searchParams.get("label");
  var store_grp = props.searchParams.get("store_grp");
  var divisionID = props.divisionID;
  const resultArray = schemaResult
    .map((schema) => ({
      fieldId: schema.fmVariableFieldId,
      value: values[schema.fieldName],
      tagName: schema.tagName,
    }))
    .filter(
      (item) =>
        item.value &&
        item.value !== "" &&
        item.fieldId !== "0" &&
        item.fieldId !== ""
    );

  const resultArray2 = schemaResult
    .filter((schema) => schema.schemaPageSubItems)
    .flatMap((schema) =>
      schema.schemaPageSubItems
        .map((subItem) => ({
          fieldId: subItem.fmVariableFieldId,
          value:
            schema.numberOfLinesToDisplay > 1
              ? values[schema.fieldName]?.[row]?.[subItem.fieldName] || ""
              : values[schema.fieldName]?.[0]?.[subItem.fieldName] || "",
          tagName: subItem.tagName,
        }))
        .filter(
          (item) =>
            item.value &&
            item.value !== "" &&
            item.fieldId !== "0" &&
            item.fieldId !== ""
        )
    );

  const combinedArray = [...resultArray, ...resultArray2];

  const stringifiedCombinedArray = JSON.stringify(combinedArray);

  const chunkSize = 1000;
  const chunks = [];
  for (let i = 0; i < stringifiedCombinedArray.length; i += chunkSize) {
    chunks.push(stringifiedCombinedArray.slice(i, i + chunkSize));
  }

  let url = `${MenuURL}/Pages/orders/DynamicImagePreview.aspx?session_id=${sessionId}&PageID=${PageID}&store_grp=${store_grp}&labelref=${labelref}&divisionID=${divisionID}`;
  chunks.forEach((chunk, index) => {
    url += `&data_chunk${index}=${encodeURIComponent(chunk)}`;
  });

  window.open(url, "popupWindow", "width=600,height=400");
}

export async function getCatalougeData({
  schemaPageFields,
  formData,
  name,
  setCatDropDown,
  setTotalSum,
  setTotalInputSum,
  calculateSum,
  calculateInputSum,
  props,
  fetchCatalogueHeaderData,
  fetchCatalogueKeyValues,
}) {
  try {
    const catData = schemaPageFields.filter(
      (x) =>
        x.prefix === "CAT" &&
        (x.catalogueSchemaType === 3 || x.catalogueSchemaType === 1) &&
        x.keyIndex > 0
    );

    if (catData.length > 0) {
      let catalogueDropDown = {};
      catData.forEach((x) => {
        catalogueDropDown[x.keyIndex] = {
          keyValues: x.keyValues,
          fieldName: x.fieldName,
          key: [],
        };
      });
      setCatDropDown(catalogueDropDown);

      // Fetch catalogue data for each row
      await Promise.all(
        (formData?.[name]?.map(async (rowData, tdkeys) => {
          // Fetch catalogue data for each column
          await Promise.all(
            catData.map(async (element) => {
              const testVal = rowData[element.fieldName];
              const lastKey = element.lastKey;

              if (testVal) {
                if (element.keyIndex === catData.length) {
                  // Fetch header data
                  await fetchCatalogueHeaderData(
                    element,
                    tdkeys,
                    testVal,
                    catalogueDropDown
                  );
                } else {
                  // Fetch key values data
                  await fetchCatalogueKeyValues(
                    element,
                    tdkeys,
                    testVal,
                    catalogueDropDown
                  );
                }
              }
            })
          );
        })) || []
      );

      // Calculate total sum
      if (formData?.[name]) {
        setTotalSum(calculateSum(props, formData?.[name]));
        setTotalInputSum(calculateInputSum(props, formData[name]));
      }
    }
  } catch (error) {
    console.error("Error fetching catalogue data:", error);
  }
}

export async function getELCData({
  schemaPageFields,
  formData,
  name,
  setELCDropDown,
  ELLValue,
  fetchParentELCHeaderData,
  tableELLValue,
  ELLSchemaItem,
}) {
  try {
    const ELCData = schemaPageFields.filter((x) => x.prefix === "ELC");
    const ELCDataWithChildList = schemaPageFields.filter(
      (x) => x.prefix === "ELC" && x.hasChildList === true
    );
    const ChildMappedSchemaItem =
      ELCDataWithChildList.length > 0
        ? ELCDataWithChildList[0].parentId.split("|")[1]
        : undefined;
    if (ELCData.length > 0) {
      let ELCDropDown = {};
      ELCData.forEach((x) => {
        ELCDropDown[x.schemaItem] = {
          keyValues: [],
          fieldName: x.fieldName,
          key: [],
        };
      });
      setELCDropDown(ELCDropDown);
      if (
        ELCData.length > 0 &&
        ChildMappedSchemaItem &&
        ELLSchemaItem == ChildMappedSchemaItem
      ) {
        await Promise.all(
          formData?.[name]?.map(async (rowData, tdkeys) => {
            // Fetch catalogue data for each column
            await Promise.all(
              ELCData.map(async (element) => {
                var testVal = rowData["ELC" + element.fieldName];
                var primaryELCLabelValue = rowData[element.fieldName];
                const parentELC = element.hasChildList;
                let ELCValue = "";
                if (element.hasChildList && primaryELCLabelValue) {
                  const mappingKey = element.parentId?.split("|")?.[1];
                  const ellKey =
                    ELLValue &&
                    typeof ELLValue === "object" &&
                    mappingKey in ELLValue
                      ? ELLValue[mappingKey]
                      : undefined;
                  if (!ellKey) return;
                  for (const [key, value] of Object.entries(element.lists)) {
                    if (parseInt(key) === parseInt(ellKey)) {
                      const option = value.find(
                        (x) => x.label === primaryELCLabelValue
                      );
                      ELCValue = option?.value;
                      break;
                    }
                  }
                } else if (
                  !element.hasChildList &&
                  tableELLValue &&
                  Object.keys(tableELLValue).length !== 0 &&
                  tableELLValue !== "{}"
                ) {
                  for (const [key, value] of Object.entries(element.lists)) {
                    const ellValueParts =
                      typeof tableELLValue === "string"
                        ? tableELLValue.split("|")
                        : [];

                    if (parseInt(key) === parseInt(ellValueParts[0])) {
                      const option = value.find(
                        (x) => x.label === primaryELCLabelValue
                      );
                      ELCValue = option?.value;
                      break;
                    }
                  }
                }
                if (ELCValue) {
                  if (parentELC) {
                    await fetchParentELCHeaderData(
                      element,
                      tdkeys,
                      ELCValue,
                      ELCDropDown
                    );
                  }
                }
              })
            );
          })
        );
      }
    }
  } catch (error) {
    console.error("Error fetching catalogue data:", error);
  }
}

export async function fetchParentELCHeaderData2(
  element,
  tdkeys,
  selectedValue,
  catalogueDropDown,
  rowIndex,
  isF9KeyPress,
  {
    setLoadingStates,
    setELCDropDown,
    searchParams,
    requestOptions,
    VIPSDataServiceURL,
  }
) {
  const keyIndex = element?.schemaItem;
  catalogueDropDown[keyIndex]["key"][tdkeys] = selectedValue;
  const getSchemaChildLinkedListItems = `${VIPSDataServiceURL}/Schema/GetSchemaChildLinkedListItems?schemaID=${searchParams.get(
    "schema_id"
  )}&itemID=${selectedValue}`;
  if (
    tdkeys === rowIndex &&
    !checkAndSetItem(catalogueDropDown, rowIndex, isF9KeyPress)
  ) {
    setLoadingStates((prevStates) => ({
      ...prevStates,
      [tdkeys]: true, // Set loading state for this row to true
    }));
    try {
      const response = await fetch(
        getSchemaChildLinkedListItems,
        requestOptions
      );
      const data = await response.json();
      catalogueDropDown[keyIndex]["keyValues"][tdkeys] = data;

      setELCDropDown(catalogueDropDown);
      //setFieldValue(`${name}[${tdkeys}].${element.fieldName}`, selectedValue);
    } catch (error) {
      console.error("Error fetching key values:", error);
    } finally {
      setELCDropDown(catalogueDropDown);
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [tdkeys]: false, // Set loading state for this row to false
      }));
    }
  }
}

export function checkAndSetItem(data, index, isF9KeyPress) {
  for (let key in data) {
    if (data[key].key && data[key].keyValues) {
      if (
        index >= 0 &&
        index < data[key].key.length &&
        data[key].keyValues[index]
      ) {
        if (
          data[key].key[index] !== "" &&
          data[key].keyValues[index].length !== 0 &&
          !isF9KeyPress
        ) {
          return true;
        }
      }
    }
  }
  return false;
}

export const parseExcelData = (data, schemaPageFields) => {
  var normalizedData = data.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const rows = normalizedData.split("\n");

  var filterSchemaPageFields = schemaPageFields.filter(
    (y) =>
      y.schemaType !== 7 &&
      (y.catalogueSchemaType === undefined || y.catalogueSchemaType !== 7)
  );

  const validRows = rows
    .map((row) => row.split("\t"))
    .filter((row) => row.length === filterSchemaPageFields.length);

  return validRows;
};

export function getCatalougeDataOnF9KeyPress(
  rowIndex,
  isF9KeyPress,
  {
    schemaPageFields,
    values,
    name,
    setCatDropDown,
    setFieldValue,
    setCatTabData,
    setTotalSum,
    setTotalInputSum,
    calculateSum,
    calculateInputSum,
    getMessage,
    catDropDown,
    store_grp,
    user_id,
    props,
    formData,
    setLoadingStates,
  }
) {
  // filter CAT fields
  const catData = schemaPageFields.filter(
    (x) =>
      x.prefix === "CAT" &&
      [1, 3].includes(x.catalogueSchemaType) &&
      x.keyIndex > 0
  );
  if (!catData.length) return;

  // prepare initial dropdown state
  const initDropDown = catData.reduce((acc, x) => {
    acc[x.keyIndex] = { keyValues: x.keyValues, fieldName: x.fieldName, key: [] };
    return acc;
  }, {});

  // merge with any existing state
  const mergedDropDown = { ...catDropDown };
  // local mutable dropdown
  let dropdown = { ...mergedDropDown };
  setCatDropDown(dropdown);

  // helper for fetch + loading toggle
  const performFetch = (url, tdkey, onSuccess) => {
    setLoadingStates((prev) => ({ ...prev, [tdkey]: true }));
    fetch(url, requestOptions)
      .then((r) => r.json())
      .then(onSuccess)
      .catch((e) => console.error(e))
      .finally(() => setLoadingStates((prev) => ({ ...prev, [tdkey]: false })));
  };

  // process only the target row
  values[name]?.forEach((rowData, tdkey) => {
    if (tdkey !== rowIndex) return;
    catData.forEach(el => {
      const val = rowData[el.fieldName];
      if (!val) return;
      // skip if already populated
      if(!isF9KeyPress) {
        if (dropdown[el.keyIndex].key?.[tdkey] ) {
          setFieldValue(`${name}[${tdkey}].${el.fieldName}`, val);
          return;
        } 
      }
      // record this key
      dropdown[el.keyIndex].key = dropdown[el.keyIndex].key || [];
      dropdown[el.keyIndex].key[tdkey] = val;
      // build keyParams from all recorded keys
      let keyParams = "";
      Object.entries(dropdown).forEach(([k, v]) => {
        const kv = v.key?.[tdkey];
        if (kv != null) keyParams += `&key${k}=${kv}`;
      });
      if (el.keyIndex === catData.length) {
        const hdrUrl =
          `${VIPSDataServiceURL}/Catalogue/GetCatalogueHeaderData?catId=${el.catId}&pageID=${el.pageId}` +
          keyParams +
          `&storeGrp=${store_grp}&userId=${user_id}`;
        performFetch(hdrUrl, tdkey, data => {
          //   dropdown[el.keyIndex].keyValues = dropdown[el.keyIndex].keyValues || [];
          //   dropdown[el.keyIndex].keyValues[tdkey] = data.map(v => ({ label: v, value: v }));
          // setCatDropDown({ ...dropdown });
          const labels = schemaPageFields.filter(
            (f) => f.keyIndex === 0
          );
          if (data.catData.length) {
            data.catData.flat().forEach((item) => {
              const fn = labels.find((l) => l.catFieldId === item.ID)?.fieldName;
              fn && setFieldValue(`${name}[${tdkey}].${fn}`, item.Value);
            });
          } else {
            alert(getMessage("noDataFound"));
            schemaPageFields
              .filter((f) => f.schemaType === 24)
              .forEach((f) => setFieldValue(`${name}[${tdkey}].${f.fieldName}`, ""));
          }
        });
        setCatTabData?.({ value: val, element: el, catalogueDetailDataKey: keyParams });
      } else {
        const vendorId = getVendorIdFromSession();
        const kvUrl =
          `${VIPSDataServiceURL}/Catalogue/GetCatalogueKeyValues?catId=${el.catId}&KeyNo=${el.keyIndex+1}` +
          keyParams +
          `&vendorId=${encodeURIComponent(vendorId)}`;
        performFetch(kvUrl, tdkey, data => {
          dropdown[el.keyIndex].keyValues = dropdown[el.keyIndex].keyValues || [];
          dropdown[el.keyIndex].keyValues[tdkey] = data.map(v => ({ label: v, value: v }));
          setCatDropDown({ ...dropdown });
        });
        setFieldValue(`${name}[${tdkey}].${el.fieldName}`, val);
      }
    });
  });

  // recalculate sums
  if (formData?.[name]) {
    setTotalSum(calculateSum(props, formData[name]));
    setTotalInputSum(calculateInputSum(props, formData[name]));
  }
}

export async function getELCDataOnF9KeyPress(
  rowIndex,
  isF9KeyPress,
  {
    schemaPageFields,
    values,
    name,
    setELCDropDown,
    ELLValue,
    fetchParentELCHeaderData2,
    ELCDropDown,
    formData,
    setTotalSum,
    setTotalInputSum,
    calculateSum,
    calculateInputSum,
    props,
    searchParams,
    requestOptions,
    VIPSDataServiceURL,
    setLoadingStates,
    tableELLValue,
  }
) {
  const ELCData = schemaPageFields.filter((x) => x.prefix === "ELC");

  if (ELCData.length > 0) {
    let ELCDropDown2 = {};
    ELCData.forEach((x) => {
      ELCDropDown2[x.schemaItem] = {
        keyValues: [],
        fieldName: x.fieldName,
        key: [],
      };
    });

    let changeDropDownVal = { ...ELCDropDown };

    setELCDropDown(changeDropDownVal);
    values?.[name].map((x, tdkeys, index) => {
      ELCData.map((element) => {
        var testVal = x["ELC" + element.fieldName];
        var primaryELCLabelValue = x[element.fieldName];
        const parentELC = element.hasChildList;
        let ELCValue = "";
        if (element.hasChildList && primaryELCLabelValue) {
          const mappingKey = element.parentId?.split("|")?.[1];
          const ellKey =
            ELLValue && typeof ELLValue === "object" && mappingKey in ELLValue
              ? ELLValue[mappingKey]
              : undefined;
          if (!ellKey) return;
          for (const [key, value] of Object.entries(element.lists)) {
            if (parseInt(key) === parseInt(ellKey)) {
              const option = value.find(
                (x) => x.label === primaryELCLabelValue
              );
              ELCValue = option?.value;
              break;
            }
          }
        }

        if (parentELC) {
          if (ELCValue) {
            fetchParentELCHeaderData2(
              element,
              tdkeys,
              ELCValue,
              changeDropDownVal,
              rowIndex,
              isF9KeyPress,
              {
                setLoadingStates,
                setELCDropDown,
                searchParams,
                requestOptions,
                VIPSDataServiceURL,
              }
            );
          }
        }
      });
    });
  }
  if (formData?.[name]) {
    setTotalSum && setTotalSum(calculateSum(props, formData?.[name]));
    setTotalInputSum &&
      setTotalInputSum(calculateInputSum(props, formData[name]));
  }
}

export function deleteItemAtIndex(data, index) {
  for (let key in data) {
    if (Array.isArray(data[key].key) && Array.isArray(data[key].keyValues)) {
      if (index >= 0 && index < data[key].key.length) {
        data[key].key.splice(index, 1);
        data[key].keyValues.splice(index, 1);
      }
    }
  }
  return data;
}

export function addMoreRowHelper({
  Lines,
  maxNoLines,
  table,
  initialValues,
  name,
  setFieldValue,
  values,
  settable,
}) {
  let addmore = [],
    initalArray = [];
  let defaultValue = Lines;
  let initialValueObj = {};
  if (initialValues[name]) {
    initialValueObj = { ...initialValues[name]?.[0] };
  }
  for (const key in initialValueObj) {
    initialValueObj[key] = "";
  }
  if (table.length + defaultValue >= maxNoLines)
    defaultValue = maxNoLines - table.length;
  for (let k = 0; k < defaultValue; k++) {
    addmore.push(table[0]);
    initalArray.push({ ...initialValueObj });
  }
  if (initialValues[name]) {
    initialValues[name] = [...initialValues[name], ...initalArray];
    setFieldValue(name, [...values[name], ...initalArray]);
  }
  settable((current) => [...current, ...addmore]);
}

export async function deleteRowHelper({
  indexToDelete,
  values,
  name,
  setDeleting,
  csvUplaodEnabled,
  initialValues,
  schemaPageFields,
  setFieldValue,
  ELCDropDown,
  setELCDropDown,
  deleteItemAtIndex,
  settable,
  formData,
  setTotalSum,
  setTotalInputSum,
  calculateSum,
  calculateInputSum,
  props,
}) {
  try {
    setDeleting(true);

    const updatedValues = [...values[name]];
    updatedValues.splice(indexToDelete, 1);
    if (!csvUplaodEnabled) {
      let initialValueObj = initialValues[name]?.[indexToDelete];
      for (const key in initialValueObj) {
        initialValueObj[key] = "";
      }
      updatedValues.push(initialValueObj);
    }

    let changeDropDownVal = { ...ELCDropDown };
    if (Object.keys(changeDropDownVal).length > 0) {
      setELCDropDown(deleteItemAtIndex(changeDropDownVal, indexToDelete));
    }
    values[name] = updatedValues;
    setFieldValue(name, updatedValues);

    let arr = [];
    for (let index = 0; index < updatedValues.length; index++) {
      arr.push(schemaPageFields);
    }
    settable(arr);
    formData[name] = updatedValues;
    setDeleting(false);
    setTotalSum(calculateSum(props, updatedValues));
    setTotalInputSum(calculateInputSum(props, updatedValues));
  } catch (error) {
    console.error("Error deleting row:", error);
    setDeleting(false);
  }
}

export const handleF8KeyPress = (
  event,
  key,
  rowIndex,
  colIndex,
  values,
  name,
  setFieldValue,
  setTotalSum,
  setTotalInputSum,
  calculateSum,
  calculateInputSum,
  props,
  context
) => {
  if (event.keyCode === 119) {
    if (rowIndex > 0) {
      if (values[name]?.[rowIndex]) {
        let columnToBeCopied = values[name]?.[rowIndex - 1][key.fieldName];
        values[name][rowIndex][key.fieldName] = columnToBeCopied;
        setFieldValue(
          `${name}[${rowIndex}][${key.fieldName}]`,
          columnToBeCopied
        );
        setTotalSum(calculateSum(props, values[name]));
        setTotalInputSum(calculateInputSum(props, values[name]));

        if (context) {
          const {
            schemaPageFields,
            setCatDropDown,
            setCatTabData,
            getMessage,
            catDropDown,
            store_grp,
            user_id,
            formData,
            ELLValue,
            ELCDropDown,
            searchParams,
            requestOptions,
            VIPSDataServiceURL,
            setELCDropDown,
            setLoadingStates,
          } = context;

          const isELCField = schemaPageFields.some(
            (f) => f.prefix === "ELC" && f.fieldName === key.fieldName
          );

          const isCatField = schemaPageFields.some(
            (f) =>
              f.prefix === "CAT" &&
              [1, 3].includes(f.catalogueSchemaType) &&
              f.keyIndex > 0 &&
              f.fieldName === key.fieldName
          );

          if (isELCField) {
            getELCDataOnF9KeyPress(rowIndex, false, {
              schemaPageFields,
              values,
              name,
              setELCDropDown,
              ELLValue,
              fetchParentELCHeaderData2,
              ELCDropDown,
              formData,
              setTotalSum,
              setTotalInputSum,
              calculateSum,
              calculateInputSum,
              props,
              searchParams,
              requestOptions,
              VIPSDataServiceURL,
              setLoadingStates,
            });
          }

          if (isCatField) {
            getCatalougeDataOnF9KeyPress(rowIndex, false, {
              schemaPageFields,
              values,
              name,
              setCatDropDown,
              setFieldValue,
              setCatTabData,
              setTotalSum,
              setTotalInputSum,
              calculateSum,
              calculateInputSum,
              getMessage,
              catDropDown,
              store_grp,
              user_id,
              props,
              formData,
              setLoadingStates,
            });
          }
        }
      }
    }
  }
};

export const handleF9KeyPress = (event, rowIndex, context) => {
  const {
    values,
    name,
    setFieldValue,
    getCatalougeDataOnF9KeyPress,
    schemaPageFields,
    setCatDropDown,
    setCatTabData,
    setTotalSum,
    setTotalInputSum,
    calculateSum,
    calculateInputSum,
    getMessage,
    catDropDown,
    store_grp,
    user_id,
    props,
    formData,
    getELCDataOnF9KeyPress,
    ELLValue,
    fetchParentELCHeaderData2,
    ELCDropDown,
    searchParams,
    requestOptions,
    VIPSDataServiceURL,
    setELCDropDown,
    setLoadingStates,
  } = context;

  if (rowIndex > 0) {
    if (values[name]?.[rowIndex]) {
      let rowToBeCopied = values[name]?.[rowIndex - 1];
      document.getElementById(event.target.id).blur();
      values[name][rowIndex] = rowToBeCopied;
      setFieldValue(`${name}[${rowIndex}]`, rowToBeCopied);
      getCatalougeDataOnF9KeyPress(rowIndex, true, {
        schemaPageFields,
        values,
        name,
        setCatDropDown,
        setFieldValue,
        setCatTabData,
        setTotalSum,
        setTotalInputSum,
        calculateSum,
        calculateInputSum,
        getMessage,
        catDropDown,
        store_grp,
        user_id,
        props,
        formData,
        setLoadingStates,
      });

      getELCDataOnF9KeyPress(rowIndex, true, {
        schemaPageFields,
        values,
        name,
        setELCDropDown,
        ELLValue,
        fetchParentELCHeaderData2,
        ELCDropDown,
        formData,
        setTotalSum,
        setTotalInputSum,
        calculateSum,
        calculateInputSum,
        props,
        searchParams,
        requestOptions,
        VIPSDataServiceURL,
        setLoadingStates,
      });
      setTotalSum(calculateSum(props, values[name]));
      setTotalInputSum(calculateInputSum(props, values[name]));
    }
  }
};

export const handleF10KeyPress = (event, rowIndex, context) => {
  const {
    values,
    name,
    setFieldValue,
    getCatalougeDataOnF9KeyPress,
    schemaPageFields,
    setCatDropDown,
    setCatTabData,
    setTotalSum,
    setTotalInputSum,
    calculateSum,
    calculateInputSum,
    getMessage,
    catDropDown,
    store_grp,
    user_id,
    props,
    formData,
    getELCDataOnF9KeyPress,
    ELLValue,
    fetchParentELCHeaderData2,
    ELCDropDown,
    searchParams,
    requestOptions,
    VIPSDataServiceURL,
    setELCDropDown,
    setLoadingStates,
  } = context;

  // Identify catalogue output field names that should be populated by API, not copied
  const catOutputFieldNames = new Set(
    schemaPageFields
      .filter((f) => f.prefix === "CAT" && f.catalogueSchemaType === 7)
      .map((f) => f.fieldName)
  );

  // Identify catalogue key fields to determine if a row already has catalogue data
  const catKeyFields = schemaPageFields.filter(
    (f) => f.prefix === "CAT" && [1, 3].includes(f.catalogueSchemaType) && f.keyIndex > 0
  );

  // ELC secondary (hasChildList=false) fields — options depend on the row's ELC parent
  const elcSecondaryFields = schemaPageFields.filter(
    (f) => f.prefix === "ELC" && f.hasChildList === false
  );
  const elcSecondaryByLabel = new Map(elcSecondaryFields.map((f) => [f.fieldName, f]));
  // Value keys ("ELC" + fieldName) handled together with their label key
  const elcSecondaryValueKeys = new Set(elcSecondaryFields.map((f) => "ELC" + f.fieldName));

  if (rowIndex > 0) {
    for (let i = 1; i <= rowIndex; i++) {
      if (values[name]?.[i]) {
        let rowToBeCopied = values[name][0];
        document.getElementById(event.target.id).blur();

        // Check if this row already has catalogue key values populated
        const rowAlreadyHasCatKeys = catKeyFields.length > 0 && catKeyFields.every(
          (f) => values[name][i][f.fieldName] && values[name][i][f.fieldName] !== ""
        );

        let rowToBeCopied2 = {};
        // Tracks ELC value keys ("ELCfieldName") already resolved with their label key
        const elcValueKeyHandled = new Set();

        Object.keys(rowToBeCopied).forEach((key) => {
          if (catOutputFieldNames.has(key)) {
            // If row already has catalogue data, preserve existing output values
            // Otherwise leave empty for API to bind
            rowToBeCopied2[key] = rowAlreadyHasCatKeys
              ? (values[name][i][key] || "")
              : "";
            return;
          }

          // ELC secondary value key ("ELC" + fieldName) — resolved alongside its label key
          if (elcSecondaryValueKeys.has(key)) {
            if (!elcValueKeyHandled.has(key)) {
              const value = values[name][i][key];
              rowToBeCopied2[key] =
                value === "NaN" || value === "" || value === undefined
                  ? rowToBeCopied[key]
                  : value;
            }
            return;
          }

          // ELC secondary label key — validate copied value against target row's options
          if (elcSecondaryByLabel.has(key)) {
            const field = elcSecondaryByLabel.get(key);
            const existingValue = values[name][i][key];

            // Target already has a value — keep it (and its paired ELC value key)
            if (existingValue && existingValue !== "" && existingValue !== "NaN") {
              rowToBeCopied2[key] = existingValue;
              rowToBeCopied2["ELC" + key] = values[name][i]["ELC" + key] || "";
              elcValueKeyHandled.add("ELC" + key);
              return;
            }

            // Target is empty — validate row 0's label against target row's available options
            const labelToCopy = rowToBeCopied[key];
            if (labelToCopy && field.lists) {
              const parentFieldId = parseInt(field.parentId?.split("|")?.[1]);
              const parentSchema = schemaPageFields.find(
                (x) => x.schemaItem === parentFieldId
              );

              if (parentSchema) {
                let targetParentDropDownValue = null;
                if (parentSchema.prefix === "ELL") {
                  const rawVal = values[name][i][parentSchema.fieldName];
                  targetParentDropDownValue =
                    rawVal && typeof rawVal === "string" && rawVal.includes("|")
                      ? rawVal.split("|")[1]
                      : rawVal;
                } else {
                  targetParentDropDownValue =
                    values[name][i]["ELC" + parentSchema.fieldName];
                }

                if (targetParentDropDownValue) {
                  let targetOptions = [];
                  for (const [k, opts] of Object.entries(field.lists)) {
                    if (parseInt(k) === parseInt(targetParentDropDownValue)) {
                      targetOptions = opts;
                      break;
                    }
                  }
                  const matchedOpt = targetOptions.find(
                    (opt) => opt.label === labelToCopy
                  );
                  if (!matchedOpt) {
                    // Label not valid for this row's parent — clear both fields
                    rowToBeCopied2[key] = "";
                    rowToBeCopied2["ELC" + key] = "";
                    elcValueKeyHandled.add("ELC" + key);
                    return;
                  }
                  // Valid — copy label and use the matched option's value
                  rowToBeCopied2[key] = matchedOpt.label;
                  rowToBeCopied2["ELC" + key] = matchedOpt.value;
                  elcValueKeyHandled.add("ELC" + key);
                  return;
                }
              }
            }

            // No parent found or target has no parent selected yet — normal copy
            const value = values[name][i][key];
            rowToBeCopied2[key] =
              value === "NaN" || value === "" || value === undefined
                ? rowToBeCopied[key]
                : value;
            return;
          }

          const value = values[name][i][key];
          rowToBeCopied2[key] =
            value === "NaN" || value === "" || value === undefined
              ? rowToBeCopied[key]
              : value;
        });
        values[name][i] = rowToBeCopied2;
        setFieldValue(`${name}[${i}]`, rowToBeCopied2);

        // Only call API for rows that didn't already have catalogue keys
        if (!rowAlreadyHasCatKeys) {
          getCatalougeDataOnF9KeyPress(i, true, {
            schemaPageFields,
            values,
            name,
            setCatDropDown,
            setFieldValue,
            setCatTabData,
            setTotalSum,
            setTotalInputSum,
            calculateSum,
            calculateInputSum,
            getMessage,
            catDropDown,
            store_grp,
            user_id,
            props,
            formData,
            setLoadingStates,
          });
          getELCDataOnF9KeyPress(i, false, {
            schemaPageFields,
            values,
            name,
            setELCDropDown,
            ELLValue,
            fetchParentELCHeaderData2,
            ELCDropDown,
            formData,
            setTotalSum,
            setTotalInputSum,
            calculateSum,
            calculateInputSum,
            props,
            searchParams,
            requestOptions,
            VIPSDataServiceURL,
            setLoadingStates,
          });
        }
      }
    }
    setTotalSum(calculateSum(props, values[name]));
    setTotalInputSum(calculateInputSum(props, values[name]));
  }
};

const getRowOptions = (
  field,
  row,
  { values, schemaPageFields, schemaPageId, itemId, schemaResult }
) => {
  if (!field.lists) return [];

  const parentPageId = parseInt(field.parentId?.split("|")?.[0]);
  const parentFieldId = parseInt(field.parentId?.split("|")?.[1]);
  let parentDropDownValue = null;

  if (parentPageId === itemId) {
    const parentSchema = schemaPageFields.find(
      (x) => x.schemaItem === parentFieldId
    );
    if (parentSchema) {
      if (parentSchema.prefix === "ELL") {
        const rawVal = row[parentSchema.fieldName];
        parentDropDownValue =
          rawVal && typeof rawVal === "string" && rawVal.includes("|")
            ? rawVal.split("|")[1]
            : rawVal;
      } else {
        parentDropDownValue = row["ELC" + parentSchema.fieldName];
      }
    }
  } else if (parentPageId === schemaPageId && schemaResult) {
    const parentSchema = schemaResult.find(
      (x) => x.schemaItem === parentFieldId
    );
    if (parentSchema) {
      const rawParentValue = values[parentSchema.fieldName];
      if (field.lists[rawParentValue] !== undefined) {
        parentDropDownValue = rawParentValue;
      } else {
        const opt = parentSchema?.options?.find(
          (x) => x.label === rawParentValue
        );
        if (opt) {
          parentDropDownValue = opt.value;
        } else if (parentSchema?.lists) {
          for (const listKey in parentSchema.lists) {
            const lOpt = parentSchema.lists[listKey]?.find(
              (x) => x.label === rawParentValue
            );
            if (lOpt) {
              parentDropDownValue = lOpt.value;
              break;
            }
          }
        }
      }
    }
  }

  if (parentDropDownValue && field.lists) {
    for (const [key, opts] of Object.entries(field.lists)) {
      if (parseInt(key) === parseInt(parentDropDownValue)) {
        return opts;
      }
    }
  }
  return [];
};

export const handleCopySecondarySize = ({
  values,
  name,
  setValues,
  schemaPageFields,
  schemaPageId,
  itemId,
  schemaResult,
}) => {
  const elcParentFields = schemaPageFields.filter(
    (f) => f.prefix === "ELC" && f.hasChildList === true
  );
  const elcSecondaryFields = schemaPageFields.filter(
    (f) => f.prefix === "ELC" && f.hasChildList === false
  );

  if (elcSecondaryFields.length === 0) return;

  const tableRows = values[name];
  if (!tableRows || tableRows.length < 2) return;

  const row0 = tableRows[0];
  const ctx = { values, schemaPageFields, schemaPageId, itemId, schemaResult };

  // Build position map from row 0
  const positionMap = {};
  for (const field of elcSecondaryFields) {
    const selectedLabel = row0[field.fieldName];
    if (!selectedLabel) continue;
    const row0Options = getRowOptions(field, row0, ctx);
    const posIdx = row0Options.findIndex((opt) => opt.label === selectedLabel);
    if (posIdx >= 0) {
      positionMap[field.fieldName] = posIdx;
    }
  }

  if (Object.keys(positionMap).length === 0) return;

  // Build updated rows array — accumulate all changes then commit once
  const newRows = tableRows.map((row, i) => {
    if (i === 0) return row;

    const hasParent =
      elcParentFields.length === 0 ||
      elcParentFields.some((f) => row[f.fieldName] && row[f.fieldName] !== "");
    if (!hasParent) return row;

    const updates = {};
    for (const field of elcSecondaryFields) {
      const posIdx = positionMap[field.fieldName];
      if (posIdx === undefined) continue;

      const rowOptions = getRowOptions(field, row, ctx);
      let targetOpt = rowOptions[posIdx];
      if (!targetOpt) {
        targetOpt =
          rowOptions.find((opt) => opt.label?.toLowerCase() === "n/a") || null;
      }
      if (!targetOpt) continue;

      updates[field.fieldName] = targetOpt.label;
      updates["ELC" + field.fieldName] = targetOpt.value;
    }

    return Object.keys(updates).length > 0 ? { ...row, ...updates } : row;
  });

  // Single setValues call — runs one validation pass, clearing any stale errors
  setValues({ ...values, [name]: newRows });
};
